import React, { useEffect, useRef, useState } from "react";
import jsQR from "jsqr";

export const QRReader = ({ onScan, setQrValue }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const scanningRef = useRef(false);
    const streamRef = useRef(null);

    useEffect(() => {
        let cancelled = false;

        const startCamera = async () => {
            try {
                // Intento 1 (frontal)
                const stream1 = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: "user" },
                    audio: false
                });

                if (!cancelled) startVideo(stream1);
            } catch (err) {
                console.warn("Frontal no disponible, usando trasera…");

                try {
                    // Intento 2 (trasera)
                    const stream2 = await navigator.mediaDevices.getUserMedia({
                        video: { facingMode: "environment" },
                        audio: false
                    });

                    if (!cancelled) startVideo(stream2);
                } catch (err2) {
                    console.error("Cámara no disponible", err2);
                }
            }
        };

        const startVideo = (stream) => {
            const video = videoRef.current;

            streamRef.current = stream;
            video.srcObject = stream;
            video.muted = true;
            video.playsInline = true;

            video.onloadedmetadata = () => {
                video.play().then(() => {
                    scanningRef.current = true;
                    scanLoop();
                }).catch((err) => {
                    console.error("Error al reproducir video:", err);
                });
            };
        };

        const scanLoop = () => {
            if (!scanningRef.current) return;

            const video = videoRef.current;
            const canvas = canvasRef.current;

            if (!video || video.readyState !== video.HAVE_ENOUGH_DATA)
                return requestAnimationFrame(scanLoop);

            const ctx = canvas.getContext("2d");

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const qr = jsQR(imageData.data, canvas.width, canvas.height);

            if (qr) {
                scanningRef.current = false; // Detiene escaneo
                setQrValue(qr.data);
                onScan(qr.data);
                return;
            }

            requestAnimationFrame(scanLoop);
        };

        startCamera();


        return () => {
            cancelled = true;
            scanningRef.current = false;
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(t => t.stop());
            }
        };
    }, [onScan]);

    return (
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <video
                ref={videoRef}
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transform: "scaleX(-1)"
                }}
                muted
                playsInline
            ></video>

            <canvas ref={canvasRef} style={{ display: "none" }}></canvas>

        </div>
    );
};
